module.exports = __webpack_public_path__ + "static/media/other-file.76417f3b.svg";